export default function About() {
  return (
    <section id="about" className="py-32 bg-[#FAFBFC]">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-center">
          <div className="lg:col-span-3 space-y-8">
            <div>
              <span className="text-sm font-bold text-[#00D9FF] uppercase tracking-[3px] whitespace-nowrap">
                About Us
              </span>
            </div>

            <h3 className="text-5xl lg:text-6xl font-bold text-black leading-tight">
              Expertise in Mobile
              <br />
              Innovation
            </h3>

            <p className="text-lg text-[#2D3748] leading-relaxed max-w-[680px]">
              At TAFARUCI SH.P.K., we specialize in creating cutting-edge iOS applications that combine elegant design with powerful functionality. Our team of experienced developers and designers work together to deliver solutions that not only meet but exceed user expectations. We focus on security, performance, and user experience to ensure every application we build stands out in the competitive mobile landscape.
            </p>
          </div>

          <div className="lg:col-span-2">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-[#00D9FF]/10 to-transparent rounded-[32px]"></div>
              <div className="relative bg-gradient-to-br from-[#F7FAFC] to-white rounded-[32px] p-8 shadow-xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/119f8a85c09102224c43ad1330ab99f8.jpg"
                  alt="Team Innovation"
                  className="w-full h-auto object-contain rounded-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
